<template>
<div class="pdf" style="width:100%;height:100%;">
  <iframe width="100%" height="100%" scrolling="yes" frameborder="no" border="0" marginwidth="0" marginheight="0" allowtransparency="yes" :src="pdfUrl"></iframe>>
</div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
export default {
  name: 'Pdf',
  data(){
      return {
          pdfUrl:"", 
        }
　 },
  computed: {
	  ...mapGetters(['qhText']) // 动态计算属性，相当于this.$store.getters.resturantName
	},
  methods:{

  },
  created(){
    if(this.$route.query.name == '用户协议'){
        this.pdfUrl = pdf_URL+'/static/pdf/乐荐用户协议.pdf';
    }else if(this.$route.query.name == '隐私政策'){
        this.pdfUrl = pdf_URL+'/static/pdf/隐私政策.pdf';
    }
  }
} 
</script>


// WEBPACK FOOTER //
// src/components/pdf/pdf.vue